<template>
  <label for="branch-places-multiselect-component" class="form-label">
    {{ $t('branch.place.list') }}
  </label>
  <TomSelect
    v-model="componentValue.selectedBranchPlaces"
    :options="{
      create: false,
      placeholder: $t('branch.place.selectMore')
    }"
    class="w-full"
    multiple
  >
    <option
      v-for="branchPlace in branchPlaces"
      :value="branchPlace.uuid"
      :key="branchPlace.uuid"
    >
      {{ branchPlace.internalName }} - ({{ branchPlace.branch.name }})
    </option>
  </TomSelect>
</template>

<script>
import { defineComponent, computed } from 'vue'
import branchPlaceApi from '../../services/branches/branch-place.api'

export default defineComponent({
  data() {
    return {
      branchPlaces: []
    }
  },
  mounted() {
    branchPlaceApi.getListAll(1, 100).then(
      response => {
        this.branchPlaces = response.data.data
      },
      error => {
        alert(error)
      }
    )
  },
  props: {
    selectedBranchPlaces: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['update:selectedBranchPlaces'],

  setup(props, { emit }) {
    const componentValue = computed({
      get: () => props.selectedBranchPlaces,
      set: value => emit('update:selectedBranchPlaces', value)
    })

    return {
      componentValue
    }
  }
})
</script>
